import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';
import PrivateRoute from '@/components/auth/PrivateRoute';
import { MENU } from '@/constants/menuCodes';

const CommonCodePage = lazy(() => import('@/pages/settings/CommonCodePage'));
const MenuPermissionPage = lazy(() => import('@/pages/settings/MenuPermissionPage'));
const UserManagementPage = lazy(() => import('@/pages/settings/UserManagementPage'));
const OrganizationManagementPage = lazy(() => import('@/pages/settings/OrganizationManagementPage'));
const LogManagementPage = lazy(() => import('@/pages/settings/LogManagementPage'));
const CompanyInfoPage = lazy(() => import('@/pages/settings/CompanyInfoPage'));
const MenuManagementPage = lazy(() => import('@/pages/settings/MenuManagementPage'));

/** 설정 모듈 라우트 */
const settingsRoutes = [
  <Route
    key="settings-codes"
    path="settings/codes"
    element={<PrivateRoute menuCode={MENU.SET_COMMON_CODE}><CommonCodePage /></PrivateRoute>}
  />,
  <Route
    key="settings-menu-permissions"
    path="settings/menu-permissions"
    element={<PrivateRoute menuCode={MENU.SET_PERMISSION}><MenuPermissionPage /></PrivateRoute>}
  />,
  // 메뉴 자체를 관리하는 화면. 기존에는 컴포넌트만 있고 라우트가 없어 접근이 불가능했다.
  <Route
    key="settings-menus"
    path="settings/menus"
    element={<PrivateRoute menuCode={MENU.SET_PERMISSION}><MenuManagementPage /></PrivateRoute>}
  />,
  <Route
    key="settings-users"
    path="settings/users"
    element={<PrivateRoute menuCode={MENU.SET_USER}><UserManagementPage /></PrivateRoute>}
  />,
  <Route
    key="settings-organizations"
    path="settings/organizations"
    element={<PrivateRoute menuCode={MENU.SET_ORGANIZATION}><OrganizationManagementPage /></PrivateRoute>}
  />,
  <Route
    key="settings-departments"
    path="settings/departments"
    element={<Navigate to="/settings/organizations" replace />}
  />,
  <Route
    key="settings-logs"
    path="settings/logs"
    element={<PrivateRoute menuCode={MENU.SET_LOG}><LogManagementPage /></PrivateRoute>}
  />,
  <Route
    key="settings-company"
    path="settings/company"
    element={<PrivateRoute menuCode={MENU.SET_COMPANY}><CompanyInfoPage /></PrivateRoute>}
  />,
];

export default settingsRoutes;
